import { mapGetters } from "vuex";
export default {
  data() {
    return {
      isPlaying: false,
      isGlobal: true,
      audioBackFuns: {},
      globalAudio: {}
    };
  },
  mounted() {
    if(this.isGlobal) {
      this.$store.commit("setGlobalAudio", new Audio());
      this.globalAudio = this._globalAudio;
    } else {
      this.globalAudio = new Audio();
    }
  
    this.init();
  },
  computed: {
    ...mapGetters({
      _globalAudio: "getGlobalAudio",
    }),
  },
  methods: {
    init() {
      if (!this.globalAudio) return;
      this.globalAudio.onended = () => {
        this.isPlaying = false;
        typeof this.audioBackFuns.onEnd === 'function' && this.audioBackFuns.onEnd()
      };
      this.globalAudio.onpause = () => {
        this.isPlaying = false;
        typeof this.audioBackFuns.onPause === 'function' && this.audioBackFuns.onPause()
      };
      this.globalAudio.onplay = () => {
        this.isPlaying = true;
        typeof this.audioBackFuns.onPlay === 'function' && this.audioBackFuns.onPlay()
      };
    },
    changeStatus(url, isList) {
      if (this.isPlaying) {
        if (isList) {
          if (url != this.globalAudio.src) {
            this.globalAudio.src = url;
            this.globalAudio.play();
            this.$emit('onPlay')
            return;
          }
        }
        this.globalAudio.pause();
      } else {
        if (url != this.globalAudio.src) this.globalAudio.src = url;
        this.globalAudio.play();
        this.$emit('onPlay')
      }
    },
    stop() {
      this.globalAudio.pause();
      this.$store.commit("setGlobalAudio", null);
    },
  },
  destroyed() {
    this.stop();
  },
};
